import { NotifyHelper } from "../../../helpers/toast";
import { eGiaoVienActionsObj } from "../../action-types/category/IGiaoVienActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const giaoVienActions = {
  ...generateActions(eGiaoVienActionsObj, "GIAO_VIEN"),
  ...generateActionForKey(eGiaoVienActionsObj, "GIAO_VIEN", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eGiaoVienActionsObj, "GIAO_VIEN", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eGiaoVienActionsObj, "GIAO_VIEN", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eGiaoVienActionsObj, "GIAO_VIEN", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
